import { isValid } from 'date-fns';
import { isLastDayOfTheMonth } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/isLastDayOfTheMonth';

// TO DO: Remove this function after date-fns upgrade is done
export const differenceInMonths = (dateLeft: Date, dateRight: Date): number => {
  if (!isValid(dateLeft) || !isValid(dateRight)) {
    return 0;
  }

  // Check if both dates are at the end of their respective months
  const isEndOfMonthLeft = isLastDayOfTheMonth(dateLeft);
  const isEndOfMonthRight = isLastDayOfTheMonth(dateRight);

  // Boolean to check partial month case when both are NOT at the end of the month
  const isPartialMonth =
    !isEndOfMonthLeft &&
    !isEndOfMonthRight &&
    dateLeft.getDate() < dateRight.getDate();

  // Boolean to check if `dateRight` is end of month but `dateLeft` is not aligned
  const isMisalignedEndOfMonth =
    isEndOfMonthRight &&
    !isEndOfMonthLeft &&
    dateLeft.getDate() <
      new Date(dateLeft.getFullYear(), dateLeft.getMonth() + 1, 0).getDate();

  // Calculate year and month difference
  const yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  const monthDiff =
    dateLeft.getMonth() -
    dateRight.getMonth() -
    (isPartialMonth || isMisalignedEndOfMonth ? 1 : 0);

  return yearDiff * 12 + monthDiff;
};
